import {
  makeResetStyles,
  shorthands
} from '@fluentui/react-components';

export const useGeneratedImagesStyles = makeResetStyles({
  paddingLeft: '42px',
  paddingRight: '42px',
  '& .loading-section': {
    '& button': {
      marginTop: '8px',
    },
    textAlign: 'center',
    marginTop: '32px',
    marginBottom: '32px',
  },
  '& .actionBottomText': {
    color: '#605e5c',
  },
  '& .title': {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('5.8px'),
    '& span': {
      fontSize: '17.4px',
      fontWeight: 400,
      lineHeight: '23.2px',
    },
    '& svg': {
      width: '29px',
      height: '29px',
    },
    marginBottom: '20px',
  },
  '& .stock-images': {
    '& .title': {
      marginTop: '20px',
    },
  },
  '& .tiles-grid-cell': {
    overflow: 'hidden',
    ...shorthands.borderRadius('8px'),
    '&:hover, &:focus-within': {
      '& .action-overlay .add-button-view.notClicked': {
        visibility: 'visible',
      },
    },
    '& .action-overlay .add-button-view.notClicked': {
      visibility: 'hidden',
    },
    '& .info-overlay': {
      position: 'absolute',
      bottom: '10px',
      left: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.733)',
      height: '29px',
      width: '29px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...shorthands.borderRadius('8px'),
    },
    '& .action-overlay': {
      position: 'absolute',
      top: '10px',
      right: '10px',
      '& .add-button-view': {
        '& svg': {
          height: '24px',
          width: '24px',
        },
        display: 'flex',
        alignItems: 'center',
        padding: '4px',
        height: '32px',
        width: '32px',
        ...shorthands.overflow('hidden', 'hidden'),
        backdropFilter: 'blur(6px)',
        backgroundColor: '#FFF',
        ...shorthands.borderRadius('999px'),
        ...shorthands.gap('2px'),
        '& .icon': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '& .addIcon': {
          marginLeft: '1px',
        },
        '& .spinnerIcon': {
          animationDuration: '1s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'linear',
          animationName: [{
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' },
          }],
        },
      },
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
});

export const useLoadingViewStyles = makeResetStyles({
  backgroundImage: 'linear-gradient(270deg, rgba(255, 255, 255, 0.4) 0%, rgba(71, 207, 250, 0.4) 20%, rgba(180, 124, 248, 0.4) 80%, rgba(255, 255, 255, 0.4) 100%)',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(233, 234, 240, 1)',
  opacity: '0.4',
  animationDuration: '3s',
  backgroundSize: '500%',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
  animationName: [{
    from: { backgroundPosition: '100%' },
    to: { backgroundPosition: '-20%' },
  }],
  ...shorthands.borderRadius('8px', '8px', '8px', '8px'),
  forcedColorAdjust: 'none',
});
